import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCloudAuth } from '../../context/CloudAuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// This component handles the Google OAuth return — the JWT arrives in the URL hash fragment.
export default function CloudAuthCallback() {
  const navigate = useNavigate();
  const { setAuthData } = useCloudAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));

    // Direct Google OAuth: JWT is in auth_token
    const authToken = params.get('auth_token');

    if (authToken) {
      try {
        // Decode the JWT payload (middle segment) to get user data
        const payload = JSON.parse(atob(authToken.split('.')[1]));
        const user = {
          _id: payload.userId,
          tenantId: payload.tenantId,
          email: payload.email,
          role: payload.role
        };
        setAuthData(authToken, user);
        navigate('/cloud/voice', { replace: true });
      } catch {
        navigate('/cloud/login?error=token_invalid');
      }
      return;
    }

    // Fallback: Emergent Auth session_id (kept for backwards compatibility)
    const sessionId = params.get('session_id');
    if (sessionId) {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      fetch(`${API_URL}/api/cloud/auth/google-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId })
      })
        .then(res => res.json())
        .then(data => {
          if (data.success && data.data?.token?.token) {
            setAuthData(data.data.token.token, data.data.user);
            navigate('/cloud/voice', { replace: true });
          } else {
            navigate('/cloud/login');
          }
        })
        .catch(() => navigate('/cloud/login'));
      return;
    }

    navigate('/cloud/login');
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0b] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-4 border-purple-500 border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-gray-400 text-sm">Signing you in with Google...</p>
      </div>
    </div>
  );
}
